// extracted by mini-css-extract-plugin
export default {"container":"CommunityManagementHeader_container__nWmOw","title":"CommunityManagementHeader_title__73BQ0","rightContainer":"CommunityManagementHeader_rightContainer__MtfMx"};